import React, { Fragment, PureComponent } from 'react';
import ReactMarkdown from 'react-markdown';
import Link from 'react-router-dom/Link';

/** @type {ReactMarkdown.NodeType[]} */
const ALLOWED_TYPES = ['link', 'linkReference', 'strong', 'paragraph'];
/** @type {ReactMarkdown.NodeType[]} */
const EXTENDED_ALLOWED_TYPES = [
	...ALLOWED_TYPES,
	'heading',
	'list',
	'listItem',
];

/**
 * A simple markdown parsing component, limited to paragraphs and links.
 *
 * @typedef {Object} Props
 * @prop {boolean} [extended] Allows headings, lists, and strong elements.
 *
 * @augments {PureComponent<Props>}
 */
export default class SimpleMarkdown extends PureComponent {
	mdContentRenderer = ({ children }) => <Fragment>{children}</Fragment>;
	mdLinkRenderer = ({ children, href }) => {
		if (href.includes('mailto') || href.includes('http')) {
			return <a href={href} target='_blank' rel='noopener noreferrer'>{children}</a>;
		}
		return <Link to={href}>{children}</Link>;
	};

	getAllowedTypes = (extended) =>
		extended ? EXTENDED_ALLOWED_TYPES : ALLOWED_TYPES;

	genContent = ({ children, extended }) => (
		<ReactMarkdown
			allowedTypes={this.getAllowedTypes(extended)}
			renderers={{
				link: this.mdLinkRenderer,
				root: this.mdContentRenderer,
			}}
			source={children}
		/>
	);

	render () {
		return this.props.children ? this.genContent(this.props) : null;
	}
}



// WEBPACK FOOTER //
// ./src/components/atoms/SimpleMarkdown/SimpleMarkdown.js